import BinIcon from '../icon/IconWrapped';
import classNames from 'classnames';
import { ButtonMoveStyled } from './styled/ButtonMoveStyled';

type TButtonMoveSize = 's' | 'xs' | 'xxs';

const buttonMoveSizeMap: Record<TButtonMoveSize, number> = {
    s: 24,
    xs: 16,
    xxs: 16,
};

interface IButtonMoveProps extends React.HTMLAttributes<HTMLButtonElement> {
    bg?: string;
    className?: string;
    direction?: 'left' | 'right';
    disabled?: boolean;
    hoverBg?: string;
    isActive?: boolean;
    size?: TButtonMoveSize;
}

function ButtonMove(props: IButtonMoveProps) {
    const {
        disabled,
        size = 's',
        direction = 'left',
        isActive,
        bg = 'transparent',
        hoverBg = 'var(--color-button-secondary-highlight)',
        className,
        ...buttonProps
    } = props;

    return <ButtonMoveStyled {...buttonProps} disabled={disabled} bg={bg} hoverBg={hoverBg}
                             className={classNames(size, className, { active: isActive })}>
        <BinIcon className={'flex-shrink-0'} name={direction === 'left' ? 'IcMoveLeft' : 'IcMoveRight'}
                 size={buttonMoveSizeMap[size]}/>
    </ButtonMoveStyled>;
}

export default ButtonMove;
